import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './Carousel.css';
import TechStack1 from '../../assets/TechStack1.png';
import TechStack2 from '../../assets/TechStack2.png';
import TechStack3 from '../../assets/TechStack5.png';
import TechStack4 from '../../assets/TechStack6.png';
import TechStack5 from '../../assets/TechStack7.png';

const Carousel = () => {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <div className="tech-stack-container">
            <Slider {...settings}>
                <div>
                    <img src={TechStack1}></img>
                </div>
                <div>
                    <img src={TechStack2}></img>
                </div>
                <div>
                    <img src={TechStack3}></img>
                </div>
                <div>
                    <img src={TechStack4}></img>
                </div>
                <div>
                    <img src={TechStack5}></img>
                </div>
            </Slider>
        </div>
    );
}

export default Carousel;